import React from 'react';

import { getSize, Size } from './utils';

interface Props {
    color: string;
    controlColor?: string;
    size?: Size;
    transparentControl?: boolean;
}

export const PlayIcon: React.FC<Props> = ({ color, controlColor = '#F9F9F9', size = 's', transparentControl }) => {
    const sizePx = getSize(size);

    return transparentControl ? (
        <svg width={sizePx} height={sizePx} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10zM7 6.272a1 1 0 011.517-.856l6.175 3.728a1 1 0 010 1.712l-6.175 3.728A1 1 0 017 13.728V6.272z"
                fill={color}
            />
        </svg>
    ) : (
        <svg width={sizePx} height={sizePx} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11z" fill={color} />
            <path
                d="M9.368 5.957A1.1 1.1 0 007.7 6.9v8.202a1.1 1.1 0 001.668.942l6.794-4.101a1.1 1.1 0 000-1.884l-6.794-4.1z"
                fill={controlColor}
            />
        </svg>
    );
};
